import { Toast, ToastContainer } from "react-bootstrap";
import { createLogger } from "../../../../utils/logger";

const logger = createLogger('ToastMessage');

export interface ToastMessageModel {
    show:boolean;
    title:string;
    message:string;
}

const ToastMessage = ({model, handleClose}) => {

  return (
    <>
      <ToastContainer className="p-3" position='bottom-end' style={{ zIndex: 99 }}>
        <Toast
          show={model.show}
          animation={true}
          autohide={true}
          onClose={()=>{
            logger.debug('close message');
            handleClose()
          }}
          bg="danger"
        >
          <Toast.Header >
            <img
              src="holder.js/20x20?text=%20"
              className="rounded me-2"
              alt=""
            />
            <strong className="me-auto">{model?.title}</strong>
            <small></small>
          </Toast.Header>
          <Toast.Body className="text-white">{model?.message}</Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};

export default ToastMessage;
